import { Button } from '@cloudscape-design/components';
import { flatMap } from 'lodash';
import { tagCell } from 'src/pages/questions/questionConfig';
import { Question } from 'src/types/helios/Question';

export const getItemValue = (item: Question, propertyKey: string): any => {
  if (!item) return '';
};

export const getSearchableFields = (item: Question) => [
  item.questionId || '',
  item.createdBy || '',
  item.createdBy || '',
  item.localizedContent.content.questionDetails.title || '',
  ...(flatMap(item.categories, (data) => [data || '']) || []),
];
const renderWithExcludedStyle = (content: string, isExcluded: boolean) => (
  <span className={isExcluded ? 'excluded-question' : ''}>{content}</span>
);

export const getQuestionSelectionTableColumns = (
  onViewDetails: (question: Question) => void,
  excludedQuestionIds: string[] = [],
) => {
  const excludedQuestionsSet = new Set(excludedQuestionIds);
  return [
    {
      id: 'questionId',
      header: 'Question ID',
      cell: (item: Question) =>
        renderWithExcludedStyle(
          item.questionId,
          excludedQuestionsSet.has(item.questionId),
        ),
    },
    {
      id: 'overview',
      header: 'Question Overview',
      cell: (item: Question) =>
        renderWithExcludedStyle(
          item.localizedContent.content.questionDetails.title,
          excludedQuestionsSet.has(item.questionId),
        ),
    },

    {
      id: 'division',
      header: 'Division',
      cell: (item: Question) => item.divisionName ?? item.division,
    },
    {
      id: 'tags',
      header: 'Tags',
      cell: (item: Question) => tagCell(item),
      width: 200,
    },
    {
      id: 'actions',
      header: 'Actions',
      cell: (item: Question) => (
        <Button iconName="external" variant="link" onClick={() => onViewDetails(item)}>
          View Details
        </Button>
      ),
    },
  ];
};
